import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { CardContentBox, CardListItem } from "./CardElements"
import { AdminUser } from "../../users/userTypes"

type ProfileCardProps = { user: AdminUser }

export const ProfileCard = ({ user }: ProfileCardProps) => {
    return (
        <CardContentBox>
            <CardListItem
                title={
                    <LocalizedStrict id="profile-user-account-id">
                        <>ID:</>
                    </LocalizedStrict>
                }
                content={user?.id}
            />

            <CardListItem
                title={
                    <LocalizedStrict id="profile-username">
                        <>Username:</>
                    </LocalizedStrict>
                }
                content={user?.username}
            />

            <CardListItem
                title={
                    <LocalizedStrict id="profile-name">
                        <>Name:</>
                    </LocalizedStrict>
                }
                content={user?.displayName}
            />

            <CardListItem
                title={
                    <LocalizedStrict id="profile-email">
                        <>Email:</>
                    </LocalizedStrict>
                }
                content={user?.email}
            />

            <CardListItem
                title={
                    <LocalizedStrict id="profile-phone-number">
                        <>Phone number:</>
                    </LocalizedStrict>
                }
                content={user?.phoneNumber}
            />
            <CardListItem
                title={
                    <LocalizedStrict id="profile-mobil-number">
                        <>Mobile number:</>
                    </LocalizedStrict>
                }
                content={user?.mobileNumber}
            />
        </CardContentBox>
    )
}
